// iOS Safari auto-zooms the page when an input with a computed font-size under
// 16px gains focus. The pdfme fill surface scales a PDF page to the phone's
// width, so its inputs render far below that and every field tap zoomed and
// shifted the layout (ONCALL-455). `maximum-scale=1` suppresses the focus zoom;
// since iOS 10 Safari ignores it for user pinch zoom, so accessibility zoom
// still works.
//
// Gated to iOS at runtime because Android Chrome DOES honor maximum-scale for
// pinch zoom — applying it statically in index.html would disable zoom there.
// (iPadOS ≥ 13 reports itself as "MacIntel", hence the maxTouchPoints check.)
const isIos =
  /iPad|iPhone|iPod/.test(navigator.userAgent) ||
  (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)

if (isIos) {
  document
    .querySelector('meta[name="viewport"]')
    ?.setAttribute(
      'content',
      'width=device-width, initial-scale=1.0, maximum-scale=1.0'
    )
}

export {}
